/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Stopped_Ago_1to3yInputs */

const en_us2_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 to 3 years ago`)
};

const pt_br2_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 1 a 3 anos`)
};

const es_419_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace 1 a 3 años`)
};

const pt_pt2_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 1 a 3 anos`)
};

const fr_fr2_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a 1 à 3 ans`)
};

const de_de2_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor 1 bis 3 Jahren`)
};

const it_it2_onboarding_experience_stopped_ago_1to3y = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_1to3yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 1 a 3 anni fa`)
};

/**
* | output |
* | --- |
* | "1 to 3 years ago" |
*
* @param {Onboarding_Experience_Stopped_Ago_1to3yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_stopped_ago_1to3y = /** @type {((inputs?: Onboarding_Experience_Stopped_Ago_1to3yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Stopped_Ago_1to3yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_stopped_ago_1to3y(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_stopped_ago_1to3y(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_stopped_ago_1to3y(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_stopped_ago_1to3y(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_stopped_ago_1to3y(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_stopped_ago_1to3y(inputs)
	return en_us2_onboarding_experience_stopped_ago_1to3y(inputs)
});
export { onboarding_experience_stopped_ago_1to3y as "onboarding.experience_stopped_ago.1to3y" }